import actionTypes from '../constants/actionTypes/calculation-data-action-types';
export const updateCalculationData = calculationData => ({
    type: actionTypes.UPDATE_CALCULATION,
    payload: calculationData
});
